
define('inlineSvg!svgs/icon/comment-16', function () {return '<span class="inline-comment-16 inline-icon"><svg width="16" height="16" viewBox="0 0 16 16"><path d="M13 0l1 1v7l-1 1H7l-2 3H4V9H2L1 8V1l1-1h11z"/></svg></span>';});

